import React, { useState } from 'react';

import { Button, DatePicker, Form, Switch, Checkbox, Row, Col, Input, Space } from 'antd';

import 'fragments/filter-inicio/filter-inicio.scss';
import { FilterInicioFragmentProps } from 'fragments/filter-inicio/interfaces';
import { useFilterInicioController } from 'fragments/filter-inicio/filter-inicio.controller';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { Typography } from 'antd/es';

import { SearchOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';

export const FilterInicioFragment: React.FC<FilterInicioFragmentProps> = (props) => {
    const { useController = useFilterInicioController } = props;
    const controller = useController(props.offset, props.limit, props.onFilterChange, props.onCleanFilter);
    const { translate } = useTranslator();
    const { RangePicker } = DatePicker;

    const [showAllFilters, setShowAllFilters] = useState(false);

    // Render
    return (
        <Form
            className={'filter-form'}
            form={controller.form}
            layout={'vertical'}
            initialValues={controller.initialValues}
            onFinish={controller.onFormSubmit}
        >
            {/* The search field carries the "Nombre" label, so it sits taller than the actions beside it;
                align="bottom" keeps Filtrar/Mas filtros level with the input itself instead of the label. */}
            <Row gutter={20} align="bottom">
                <Col xs={24} sm={16}>
                    <Form.Item name="searchText" label={'Nombre'}>
                        <Input
                            size={'middle'}
                            prefix={<SearchOutlined />}
                            placeholder={'Ingrese el nombre del propietario o inquilino'}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={8}>
                    <Form.Item className={'filter-actions'}>
                        <Space>
                            {controller.isCleanFilterVisible && (
                                <Button onClick={controller.cleanFilter} size={'middle'}>
                                    Limpiar Filtros
                                </Button>
                            )}
                            <Button type="primary" htmlType="submit" size={'middle'}>
                                Filtrar
                            </Button>
                            {/* Label first, then a clear gap, then the caret. The spacing and the vertical
                                centring both live in `.more-filters-toggle`, so they hold at every
                                breakpoint instead of depending on the text baseline. */}
                            <a
                                className={'more-filters-toggle'}
                                onClick={() => {
                                    setShowAllFilters(!showAllFilters);
                                }}
                            >
                                {showAllFilters ? 'Menos filtros' : 'Mas filtros'}
                                {showAllFilters ? <UpOutlined /> : <DownOutlined />}
                            </a>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
            {showAllFilters && (
                <Row gutter={20}>
                    <Col xs={24} sm={9} md={8}>
                        <Form.Item
                            label={translate({ key: 'follow-ups.payment-date' })}
                            labelAlign="left"
                            labelCol={{ span: '20' }}
                            name="date"
                            wrapperCol={{ span: '24' }}
                        >
                            <RangePicker picker="month" size={'middle'} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={10} md={6}>
                        <Form.Item name="followUpStatus" label={translate({ key: 'follow-ups.state' })}>
                            <Checkbox.Group>
                                <Row>
                                    <Col>
                                        <Checkbox onChange={controller.filterSelectedFunction} value="expired">
                                            <Typography.Text>
                                                {translate({ key: 'follow-ups.in-arrears' })}
                                            </Typography.Text>
                                        </Checkbox>
                                    </Col>
                                    <Col>
                                        <Checkbox onChange={controller.filterSelectedFunction} value="pending">
                                            <Typography.Text>
                                                {translate({ key: 'follow-ups.pending' })}
                                            </Typography.Text>
                                        </Checkbox>
                                    </Col>
                                    <Col>
                                        <Checkbox onChange={controller.filterSelectedFunction} value="isPaid">
                                            <Typography.Text>{translate({ key: 'follow-ups.paid' })}</Typography.Text>
                                        </Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={4}>
                        <Form.Item
                            label={translate({ key: 'follow-ups.unpaid-services' })}
                            labelAlign="left"
                            labelCol={{ span: '24' }}
                            name="servicesNotPaid"
                            wrapperCol={{ span: '24' }}
                            valuePropName={'checked'}
                        >
                            <Switch />
                        </Form.Item>
                    </Col>
                </Row>
            )}
        </Form>
    );
};
